import * as React from "react";
import {
  Dialog,
  DialogFooter,
  DialogType,
  IIconProps,
  IStackProps,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  Panel,
  PanelType,
  ActionButton,
  Breadcrumb
} from "@fluentui/react";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { IFolderPanelInfo } from "../../interfaces/IFolderPanelInfo";
import { RootState } from "../../redux";
import { connect, ConnectedProps } from "react-redux";
import { FileTypeEnum } from "../enums/fileTypeEnum";
import authModule from "../../../../utilities/AuthModule";
import {
  getDriveItemSharepointUniqueId,
  getItem,
  getItemWebViewUrl,
  getList,
  getSharePointDocumentLibrarySharepointId,
  getTeamChannelInfo
} from "../../services/GraphService";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { SharePointFolderContentTypeIds, sharePointInternalFileName, teamDocumentLibrary, validSaveModes } from "../../config/constants";
import { IFolderPanelHelper } from "../../interfaces/IFolderPanelHelper";
import { FolderPanelHelperFactory } from "../helpers/folderPanel/FolderPanelHelperFactory";
import {
  addWorkingDirectory,
  addWorkingDirectories,
  resetWorkingDirectories
} from "../../redux/modules/workingDirectory";
import { setLocationBeforeSaving } from "../../redux/modules/oneDrive";
import { FolderTypeHelper } from "../helpers/folderTypeHelper";
import { FolderTypeEnum } from "../enums/FolderTypeEnum";
import { FolderTypeIconQuery } from "../helpers/folderTypeIconQuery";
import { AccessLicenseHelper } from "../helpers/accessLicenseHelper";
import { ItemCheckFactory } from "../helpers/ItemCheck/ItemCheckFactory";
import { ComponentTypes } from "../../config/config";
import { ISiteInfo } from "../../interfaces/ISiteInfo";
import { SearchedSharepointFoldersDirectoryBuilder } from "../helpers/searchedSharepointFoldersDirectoryBuilder";
import { SearchedOneDriveDirectoryBuilder } from "../helpers/searchedOneDriveDirectoryBuilder";
import { IOneDriveFolder } from "../../interfaces/IOneDriveFolder";
import { IStoreItem } from "../../interfaces/IStoredItem";
import { MovePinnedItemDown, MovePinnedItemUp, addPinnedItem, getPinnedFolderIndex, removePinnedItem } from "../../redux/modules/pinnedItems";
import { removeRecentItem as removeRecentItemRedux } from "../../redux/modules/recentItems";
import { StoreItemHelper } from "../helpers/storeItemHelper";
import savingLocationStructureModule from "../../../../utilities/SavingLocationStructureModule";
import { setSavingLocation } from "../../redux/modules/savingLocation";
import { logger } from "../../../../utilities/logger";
import { setExpandedItem } from "../../redux/modules/expanders";
import { expanderConstants } from "../../redux/models/constants/expanders";
import { IExpander } from "../../redux/models/IExpander";
import generalModule from "../../../../utilities/GeneralModule";
import { tryDecodeUriComponent } from "../../../../utilities/EncodeDecode";
import { CMPermissionsPanel } from "../../../../contentManager/Panels/CMPermissionsPanel";
import { OpenInBrowser } from "../../../../utilities/BrowserUtils";
import { removeSuggestedItem } from "../../redux/modules/suggestedItems";
import * as microsoftTeams from "@microsoft/teams-js"
import { ModeEnum } from "../enums/modeEnum";
import shareToTeams from "../../../../contentManager/Services/ShareToTeamsService";
import { CMFileInfoPanel, InfoPanelMode } from "../../../../contentManager/Panels/CMFileInfoPanel";
import { SharePointInputData } from "../../interfaces/props/SharePointInputData";
import { CMFileSharePanel, SharePanelMode } from "../../../../contentManager/Panels/CMFileSharePanel";
import { getItemPathArray } from "../helpers/UrlHelper";
import { isTeamsChannelLibraryRootChannel } from "../helpers/teamsChannelLocationHelper";
import { breadCrumbContainerStyles, breadCrumbStyles } from "../../config/controlStyles";
import { EmailCreatorFactory } from "../helpers/emailAttachment/EmailCreatorFactory";
import { isMobile } from "../../styles/mobileStyles";
import { ArrowBetweenDown20Regular } from "../_v2/components/SvgIcons/ArrowBetweenDown20Regular";
import { ArrowBetweenUp20Regular } from "../_v2/components/SvgIcons/ArrowBetweenUp20Regular";
import { DeleteArrowBack20Regular } from "../_v2/components/SvgIcons/DeleteArrowBack20Regular";
import { Info20Regular } from "../_v2/components/SvgIcons/Info20Regular";
import { Key20Regular } from "../_v2/components/SvgIcons/Key20Regular";
import { Link20Regular } from "../_v2/components/SvgIcons/Link20Regular";
import { LinkAdd20Regular } from "../_v2/components/SvgIcons/LinkAdd20Regular";
import { MailLink20Regular } from "../_v2/components/SvgIcons/MailLink20Regular";
import { OpenFolder20Regular } from "../_v2/components/SvgIcons/OpenFolder20Regular";
import { PeopleTeam20Regular } from "../_v2/components/SvgIcons/PeopleTeam20Regular";
import { Pin20Regular } from "../_v2/components/SvgIcons/Pin20Regular";
import { PinOff20Regular } from "../_v2/components/SvgIcons/PinOff20Regular";
import { Save20Regular } from "../_v2/components/SvgIcons/Save20Regular";
import { Share20Regular } from "../_v2/components/SvgIcons/Share20Regular";
import { StarOff20Regular } from "../_v2/components/SvgIcons/StarOff20Regular";

const rowProps: IStackProps = { horizontal: true };
const tokens = {
  spinnerStack: {
    childrenGap: 5
  }
};

const mapStateToProps = (state: RootState) => {
  return {
    mode: state.mode.mode,
    workingDirectories: state.workingDirectories.workingDirectories,
    currentDirectory:
      state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1],
    oneDriveRootDetails: state.workingDirectories.oneDriveRootDetails,
    user: state.user,
    sites: state.sharePointInfo.sites,
    teams: state.teams.teams,
    pinned: state.pinned,
    suggested: state.suggested,
    recent: state.recent,
    expanders: state.expanders,
    tenantEnablePermissionManagement: state.tenantInfo?.enablePermissionManagement,
    account: state.user.account,
    enableSharing: state.tenantInfo?.enableSharing,
    isTessEnabled: state.tenantInfo?.isTessEnabled
  };
};

const mapDispatchToProps = {
  addWorkingDirectory,
  addWorkingDirectories,
  resetWorkingDirectories,
  setLocationBeforeSaving,
  setSavingLocation,
  addPinnedItem,
  removePinnedItem,
  removeRecentItemRedux,
  setExpandedItem,
  removeSuggestedItem,
  MovePinnedItemDown,
  MovePinnedItemUp
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface FolderOptionPanelProps extends PropsFromRedux {
  info: IFolderPanelInfo;
  dismissPanel: () => void;
  folderUpdated?: (folderOptionPanelInfo: IFolderPanelInfo, newFolderName: string) => void;
}

// const unpinIcon: IIconProps = { iconName: "Unpin" };
// const pinIcon: IIconProps = { iconName: "Pin" };
// const suggestionsIcon: IIconProps = { iconName: "Unfavorite" };
// const openIcon: IIconProps = { iconName: "OpenFolderHorizontal" };
// const shareToTeamsIcon: IIconProps = { iconName: "TeamsLogo" }
// const saveIcon: IIconProps = { iconName: "Save" };
// const removeFromRecentIcon = { iconName: "RemoveFromTrash" };
// const sitePermissions = { iconName: "Permissions" };
// const iconUp = { iconName: "Up" }
// const iconDown = { iconName: "Down" }
// const propertiesIcon = { iconName: "Info" };
// const shareIcon = { iconName: "Share" };
// const linkIcon: IIconProps = { iconName: "AddLink" };
// const copyLinkIcon = { iconName: "Link" };

const mainLevelTypes: FolderTypeEnum[] = [FolderTypeEnum.sharepointHubSite, FolderTypeEnum.sharepointSite, FolderTypeEnum.teamMainSite, FolderTypeEnum.oneDrive, FolderTypeEnum.docubird];

const FolderOptionPanel: React.FunctionComponent<FolderOptionPanelProps> = props => {
  const languageStrings = React.useContext(LanguageContext);

  const [teamsContext, setTeamsContext] = React.useState(null);
  const [isFolderPinned, setIsFolderPinned] = React.useState<boolean>(false);
  const [pinnedFolderIndex, setPinnedFolderIndex] = React.useState<number>(-1);
  const [folderPanelHelper, setFolderPanelHelper] = React.useState<IFolderPanelHelper>(null);
  const [isFolderDeletedDialogHidden, setIsFolderDeletedDialogHidden] = React.useState(true);
  const [isTeamChannelInfoLoading, setIsTeamChannelInfoLoading] = React.useState<boolean>(false);
  const [isAwaitingPinAction, setIsAwaitingPinAction] = React.useState<boolean>(false);
  const [isAwaitingRecentAction, setIsAwaitingRecentAction] = React.useState<boolean>(false);
  const [isAwaitingSaveAction, setIsAwaitingSaveAction] = React.useState<boolean>(false);
  const [isPermissionsPanelOpen, setIsPermissionsPanelOpen] = React.useState<boolean>(false);
  const [messageSendInProcess, setMessageSendInProcess] = React.useState<boolean>(false);
  const [sharePointIds, setSharePointIds] = React.useState(null);
  const [folderName, setFolderName] = React.useState<string>();
  const [folderPathArray, setFolderPathArray] = React.useState<string[]>();

  const hideFolderDeletedDialog = () => {
    if (props.info.isARecentItem) {
      removeRecentItem();
    }
    else if (props.info.isFromSuggestedItems) {
      removeSuggestedItem();
    }
    else {
      unpinFolder();
    }
    setIsFolderDeletedDialogHidden(true);
  }

  const showFolderDeletedDialog = () => {
    setIsFolderDeletedDialogHidden(false);
  }

  React.useEffect(() => {
    if (props?.mode === ModeEnum.contentManagerTeams) {
      microsoftTeams.getContext((context) => {
        setTeamsContext(context);
      });
    }
  }, [props?.mode]);

  React.useEffect(() => {
    setFolderName(props.info?.folder?.name);
  }, [props.info?.folder?.name])

  React.useEffect(() => {
    if (props.info?.folderType === FolderTypeEnum.sharepointSite || props.info?.folderType === FolderTypeEnum.sharepointHubSite) {
      setFolderPathArray([ComponentTypes.SharePoint, props.info?.folder?.name]);
    }
    else if (props.info?.folderType === FolderTypeEnum.teamMainSite) {
      setFolderPathArray([ComponentTypes.Teams, props.info?.folder?.name]);
    }
    else if (props.info?.folderType === FolderTypeEnum.docubird) {
      setFolderPathArray([ComponentTypes.Docubird, props.info?.folder?.name]);
    }
    else {
      getFolderDetails(props.info?.folder?.driveId, props.info?.folder?.id, props.info?.locations?.some(l => l?.type === ComponentTypes.Docubird));
    }
  }, [props.info?.folderType, props.info?.folder?.id, props.info?.folder?.driveId, props.info?.folder?.name]);

  React.useEffect(() => {
    if (props.info.isOpen) {
      try {
        const setupAsyncWrapper = async () => {
          const isTeamChannelWithoutDriveData = props.info.folderType === FolderTypeEnum.teamChannel && props.info.teamChannelInfo;
          if (isTeamChannelWithoutDriveData) {
            await setupTeamChannelInfo();
          }

          if (props.info.isFromHomePage
            && !(props.isTessEnabled && (props.info.tessAccountId || props.info.tessProjectId))
            && !(await CheckIfItemExists())) {
            showFolderDeletedDialog();
            return;
          }

          const folderType = getFolderType();
          const factory = new FolderPanelHelperFactory(
            props.addWorkingDirectory,
            props.addWorkingDirectories,
            folderType
          );

          setFolderPanelHelper(
            factory.create(
              props.info,
              !props.info.locations ? props.currentDirectory : props.info.locations[props.info.locations.length - 1],
              languageStrings
            )
          );
        };

        setupAsyncWrapper();
      }
      catch (e) {
        logger(e, "FolderOptionPanel.tsx (useEffect)");
      }
    }
  }, [props.info.isOpen]);

  React.useEffect(() => {
    const pinnedItemIndex: number = getPinnedFolderIndex(props.info?.folder?.driveId, props.info?.folder?.id, props.pinned.pinnedItems);
    setIsFolderPinned(pinnedItemIndex > -1);
    setPinnedFolderIndex(pinnedItemIndex);
  }, [props.info?.folder?.driveId, props.info?.folder?.id, props.pinned?.pinnedItems]);

  const setupTeamChannelInfo = async () => {
    setIsTeamChannelInfoLoading(true);
    const result = await getTeamChannelInfo(props.info.teamChannelInfo);
    props.info.folder = { ...props.info.folder, id: isTeamsChannelLibraryRootChannel(props.info.teamChannelInfo) ? null : result.driveItemId, driveId: result.driveId };
    props.info.driveItemWebUrl = result.driveItemWebUrl;
    setIsTeamChannelInfoLoading(false);
  };

  const getFolderType = (): FolderTypeEnum => {
    return !props?.info?.folderType
      ? FolderTypeHelper.getType(props.info.locations)
      : props?.info?.folderType;
  }

  const CheckIfItemExists = async () => {
    const factory = new ItemCheckFactory(props.info.folder.driveId, props.info.folder.sharePointListId, props.info.siteId);
    const itemChecker = factory.createItemChecker(props.info.folderType, props?.info?.isTeamsSiteInsideSharepoint);
    return await itemChecker.doesItemExist(props.info.folder.id);
  };

  const pinFolderRedux = async () => {
    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(true);
    } else {
      setIsFolderPinned(true);
    }

    try {
      let sharePointListId: string;
      let sharePointUniqueId: string;
      let contentTypeId: string;

      const locations: IPageSettings[] = await getLocations();
      if (props.info.folder.isSearched) {
        const finalLocation: IPageSettings = locations?.length > 0 ? locations[locations.length - 1] : null;
        sharePointListId = finalLocation?.sharePointListId;
        sharePointUniqueId = finalLocation?.sharePointUniqueId;
        contentTypeId = finalLocation?.contentTypeId;
        props.info.folder.contentTypeId = contentTypeId;
      }

      if (props?.info?.isTeamsSiteInsideSharepoint) {
        props.info.folderType = FolderTypeEnum.teamMainSite;
      }

      const folderTypeIcon = FolderTypeIconQuery.getIconType(
        props.info.folderType,
        props.info.folder,
        props.currentDirectory?.isTeamsFolder || props?.currentDirectory?.type === ComponentTypes.Teams
      );

      const item: IStoreItem = {
        driveId: props.info.folder.driveId,
        locations: [...locations],
        name: props.info.folder.name,
        itemId: props.info.folder.id,
        fileType: FileTypeEnum.folder,
        folderTypeIcon: folderTypeIcon,
        datePinned: new Date(),
        folderId: props.info.folder.id,
        webUrl: props.info.webUrl,
        sharePointListId: sharePointListId ?? props.info.folder.sharePointListId,
        isTeamsSiteInsideSharepoint: props?.info?.isTeamsSiteInsideSharepoint,
        contentTypeId: contentTypeId ?? props.info.folder.contentTypeId,
        sharePointUniqueId: sharePointUniqueId ?? props.info.folder.sharePointUniqueId,
        siteId: props.info.siteId ?? props.info.folder?.siteId,
        isSharedTeam: props.info.folder.isSharedTeam,
        teamChannelId: props.info.teamChannelInfo?.channelId,
        tessAccountId: props.info.tessAccountId,
        tessProjectId: props.info.tessProjectId,
        isList: props.info.folder?.isList
      };
      StoreItemHelper.removeSaveLocation(item.locations);

      const account = await authModule.getAccount();
      props.addPinnedItem(account.accountId, item);

      const isPinnedSectionCollapsed = props.expanders[expanderConstants.home.pinned];
      if (isPinnedSectionCollapsed) {
        const pinnedExpanderState: IExpander = { toggle: false, property: expanderConstants.home.pinned }
        props.setExpandedItem(pinnedExpanderState);
      }
    } catch (error) {
      logger(error, "FolderOptionsPanel.tsx (PinFolderRedux)");
    }

    // setIsFolderPinned(true);
    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(false);
      props.dismissPanel();
    }
  };

  const getLocations = async () => {
    if (props.info.folder.isSearched) {
      return props.info.folderType === FolderTypeEnum.sharepoint
        ? await getSharepointSearchedLocations()
        : await getOneDriveSearchedLocations();
    }

    return !props.info.locations
      ? [...props.workingDirectories, ...[await getFolderFinalLocation()]]
      : props.info.locations;
  };

  const getSharepointSearchedLocations = async (): Promise<IPageSettings[]> => {
    const directoryBuilder = new SearchedSharepointFoldersDirectoryBuilder(
      props.sites,
      props.teams,
      props.currentDirectory?.type,
      props.info.isTeamsFolder || props?.currentDirectory?.type === ComponentTypes.Teams
    );

    return await directoryBuilder.getFolderDirectories(props.info.folder as any);
  };

  const getOneDriveSearchedLocations = async (): Promise<IPageSettings[]> => {
    const directoryBuilder = new SearchedOneDriveDirectoryBuilder(props.currentDirectory.webUrl, props.currentDirectory.sharePointListId);
    return await directoryBuilder.getFolderDirectories(props.info.folder as IOneDriveFolder);
  };

  const removeRecentItem = () => {
    setIsAwaitingRecentAction(true);
    try {
      props.removeRecentItemRedux(props.user.account.accountId, {
        itemId: props.info.folder.id,
        driveId: props.info.folder.driveId
      }, FileTypeEnum.folder);
    } catch (error) {
      logger(error, "FolderOptionsPanel.tsx (removeRecentItem)");
    }
    setIsAwaitingRecentAction(false);
    props.dismissPanel();
  };

  const removeSuggestedItem = async () => {
    try {
      props.removeSuggestedItem(
        props.account.accountId,
        props.mode,
        props.account.username,
        {
          itemId: props.info.folder.id,
          driveId: props.info.folder.driveId
        }
      );
    } catch (error) {
      logger(error, "FolderOptionsPanel.tsx (removeSuggestedItem)");
    }
    props.dismissPanel();
  }

  const getFolderFinalLocation = async (): Promise<IPageSettings> => {
    return await folderPanelHelper.getFolderFinalLocation();
  };

  const unpinFolder = () => {
    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(true);
    } else {
      setIsFolderPinned(false);
    }

    try {
      props.removePinnedItem(props.user.account.accountId, {
        itemId: props.info.folder.id,
        driveId: props.info.folder.driveId
      }, FileTypeEnum.folder)
    } catch (error) {
      logger(error, "FolderOptionsPanel.tsx (unpinFolder)");
    }

    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(false);
      props.dismissPanel();
    }
  };

  const openFolderInBrowser = async () => {
    if (mainLevelTypes.some(item => item === props.info.folderType)) {
      let mainLevelUrl: string = props.info.webUrl;
      if ((!mainLevelUrl || mainLevelUrl.length === 0) && props.info.locations?.length > 0) {
        mainLevelUrl = props.info.locations[0].webUrl;
      }

      if (mainLevelUrl) {
        OpenInBrowser(mainLevelUrl);
        return;
      }
    }

    const url = await getItemWebViewUrl(
      await authModule.getGraphAccessToken(),
      props.info.folder.driveId,
      props.info.folder.id
    );

    OpenInBrowser(url);
  };

  const metaDataUpdated = React.useCallback(async (item: any, inputValuesToSave: SharePointInputData[], selectedContentTypeId: string, extention?: string) => {
    generalModule.setIsFileInfoPanelOpen(false);

    const newfolderName = inputValuesToSave.find(x => x.internalName === sharePointInternalFileName)?.value;
    if (newfolderName && newfolderName !== folderName) {
      setFolderName(newfolderName);
      if (props.folderUpdated) {
        props.folderUpdated(props.info, newfolderName);
      }
    }

    setIsFolderPropertiesPanelOpen(false);
  }, [props, folderName]);

  const save = async () => {
    setIsAwaitingSaveAction(true);

    const folderLocationsStructure = await getLocations();
    savingLocationStructureModule.setSavingLocationStructure(folderLocationsStructure);

    if (props.info.folder.isSearched) {
      if (props.info.folderType === FolderTypeEnum.sharepoint) {
        const site: ISiteInfo = props.sites.find(site => site.id === props.info.folder.siteId);
        const finalLocation: IPageSettings = folderLocationsStructure?.length > 0 ? folderLocationsStructure[folderLocationsStructure.length - 1] : null;
        await saveSharepointSearchedFolder(site, finalLocation?.sharePointListId, finalLocation?.sharePointUniqueId, finalLocation?.contentTypeId);
      }
      else {
        await saveOneDriveSearchedFolder(folderLocationsStructure);
      }
    }
    else {
      updateSavingLocation();
      folderPanelHelper.save();
    }

    setIsAwaitingSaveAction(false);
    props.dismissPanel();
  };

  const saveSharepointSearchedFolder = async (site: ISiteInfo, sharepointListId: string, sharePointUniqueId: string, contentTypeId: string): Promise<void> => {
    const item = {
      id: props.info.folder?.id,
      parentId: props.info.folder?.driveId,
      type: ComponentTypes.Saving,
      siteId: props.info.folder.siteId,
      siteDisplayName: site.name,
      webUrl: site.webUrl,
      fileTitle: props.info.folder.name,
      directory: props.info.folder.webUrl.replace(`${site.webUrl}/`, ""),
      DocumentLibrary: getDocumentLibrary(site),
      displayName: languageStrings.Properties,
      isTeamsFolder: props.currentDirectory.isTeamsFolder,
      sharePointListId: sharepointListId ?? await getSharePointDocumentLibrarySharepointId(props.info.folder?.driveId),
      sharePointUniqueId: sharePointUniqueId ?? await getDriveItemSharepointUniqueId(props.info.folder?.driveId, props.info.folder?.id),
      contentTypeId: contentTypeId
    };
    props.addWorkingDirectory(item);
  };

  const saveOneDriveSearchedFolder = async (searchedLocations: IPageSettings[]): Promise<void> => {
    updateSavingLocation();

    props.info.folder.webUrl;
    const directory = tryDecodeUriComponent(props.info?.folder?.webUrl.replace(`${props.currentDirectory?.webUrl}/`, ""));
    await props.info.saveToOneDrive(
      props.info.folder.name,
      searchedLocations[searchedLocations.length - 1],
      directory,
      props.workingDirectories,
      searchedLocations
    );
  };

  const updateSavingLocation = () => {
    const folderType = getFolderType();
    if (folderType == FolderTypeEnum.oneDrive || folderType == FolderTypeEnum.oneDriveSubFolder) {
      const saveDestination = savingLocationStructureModule.getSavingDestination();
      props.setSavingLocation(
        {
          display: saveDestination.displayName,
          webUrl: saveDestination.webUrl,
          directory: saveDestination.directory
        },
        true
      );
    }
  }

  const getDocumentLibrary = (site: ISiteInfo) => {
    const result = props.info.folder.webUrl.replace(`${site.webUrl}/`, "").split("/")[0];
    return teamDocumentLibrary.defaultDirectory ? teamDocumentLibrary.defaultName : result;
  };

  const dialogContentProps = {
    type: DialogType.largeHeader,
    title: languageStrings.FolderDeleted,
    closeButtonAriaLabel: "Close",
    subText: languageStrings.FolderRecentlyDeleted
  };

  const folderDeletedDialog = (
    <Dialog hidden={isFolderDeletedDialogHidden} onDismiss={hideFolderDeletedDialog} dialogContentProps={dialogContentProps}>
      <DialogFooter>
        <PrimaryButton autoFocus onClick={hideFolderDeletedDialog} text="Ok" />
      </DialogFooter>
    </Dialog>
  );

  const shareToTeamsHandler = async () => {
    setMessageSendInProcess(true);
    const url = await getItemWebViewUrl(
      await authModule.getGraphAccessToken(),
      props.info.folder.driveId,
      props.info.folder.id
    );

    shareToTeams(
      props?.info?.folder?.driveId,
      props?.info?.folder?.id,
      false,
      props?.info?.folder?.name,
      props?.info?.folder?.contentTypeId,
      props?.info.webUrl ?? url ?? ""
    );
  }

  const shareToTeamsButton = teamsContext !== null && (teamsContext.frameContext === "task" || teamsContext.frameContext === "content") &&
    <Stack {...rowProps} tokens={tokens.spinnerStack}>
      <ActionButton
        // iconProps={shareToTeamsIcon}
        onRenderIcon={() => <PeopleTeam20Regular />}
        allowDisabledFocus
        disabled={isTeamChannelInfoLoading}
        onClick={() => shareToTeamsHandler()}
      >
        {languageStrings.ShareToTeams}
      </ActionButton>
      {messageSendInProcess && <Spinner size={SpinnerSize.small} />}
    </Stack>;

  const otherButtonsNeedingLicensedAccess = () => {
    if (!props.info.locations && !props?.currentDirectory?.type) return null; // avioding initial startup errors
    return (
      AccessLicenseHelper.canAccessItem(
        props.user.licenseType,
        props.info.locations ? props.info.locations[0]?.type : props.currentDirectory.type
      ) && (
        <>
          {(props.user.tenantAllowOpenInSharePoint ?? true) && !props.info?.folder.isSharedTeam &&
            <Stack {...rowProps} tokens={tokens.spinnerStack}>
              <ActionButton
                // iconProps={openIcon}
                onRenderIcon={() => <OpenFolder20Regular />}
                allowDisabledFocus
                disabled={isTeamChannelInfoLoading}
                onClick={() => openFolderInBrowser()}
              >
                {languageStrings.OpenFolderInBrowser}
              </ActionButton>
              {isTeamChannelInfoLoading && <Spinner size={SpinnerSize.small} />}
            </Stack>}
          {!isMobile
            && (props.mode === ModeEnum.mailCompose || props.mode === ModeEnum.mailRead)
            && (props.info?.folderType === FolderTypeEnum.sharepoint || props.info?.folderType === FolderTypeEnum.oneDriveSubFolder)
            && props.info?.folder?.id
            && props.info?.folder?.driveId
            && <ActionButton
              // iconProps={linkIcon}
              onRenderIcon={() => props.mode === ModeEnum.mailCompose ? <LinkAdd20Regular /> : <MailLink20Regular />}
              allowDisabledFocus
              onClick={() => addShareableLink()}
            >
              {props.mode === ModeEnum.mailCompose ? languageStrings.InsertAsLink : languageStrings.CreateEmailWithLink}
            </ActionButton>}
          {props.enableSharing
            && (props.info?.folderType === FolderTypeEnum.sharepoint || props.info?.folderType === FolderTypeEnum.oneDriveSubFolder)
            && props?.info?.folder?.id
            && <>
              <Stack horizontal>
                <ActionButton
                  // iconProps={shareIcon}
                  onRenderIcon={() => <Share20Regular />}
                  allowDisabledFocus
                  onClick={() => {
                    openSharePanel(SharePanelMode.Share);
                  }}
                >
                  {languageStrings.Share}
                </ActionButton>
              </Stack>
              <Stack horizontal>
                <ActionButton
                  // iconProps={copyLinkIcon}
                  onRenderIcon={() => <Link20Regular />}
                  allowDisabledFocus
                  onClick={() => {
                    openSharePanel(SharePanelMode.Copy);
                  }}
                >
                  {languageStrings.CopyLink}
                </ActionButton>
              </Stack>
            </>}
          {isSharePanelOpen && <CMFileSharePanel
            panelIsOpen={isSharePanelOpen}
            closePanel={() => setIsSharePanelOpen(false)}
            items={[getItemToShare()]}
            mode={sharePanelModeRef.current}
            isContainer={true}
          />}
          {props?.info?.folder?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && folderPropertiesButton}
          {validSaveModes.some(item => item === props.mode) &&
            !mainLevelTypes.some(item => item === props.info.folderType) && !props.info.folder.isSaveDisabled && (
              <Stack {...rowProps} tokens={tokens.spinnerStack}>
                <ActionButton
                  // iconProps={saveIcon}
                  onRenderIcon={() => <Save20Regular />}
                  allowDisabledFocus
                  disabled={isTeamChannelInfoLoading || isAwaitingSaveAction}
                  onClick={() => save()}
                >
                  {languageStrings.Save}
                </ActionButton>
                {(isTeamChannelInfoLoading || isAwaitingSaveAction) && <Spinner size={SpinnerSize.small} />}
              </Stack>
            )}
        </>
      )
    );
  };

  const [isFolderPropertiesPanelOpen, setIsFolderPropertiesPanelOpen] = React.useState(false);
  const [isSharePanelOpen, setIsSharePanelOpen] = React.useState(false);

  const sharePanelModeRef = React.useRef<SharePanelMode>(SharePanelMode.Share);
  const openSharePanel = React.useCallback((mode: SharePanelMode) => {
    sharePanelModeRef.current = mode;
    setIsSharePanelOpen(true);
  }, []);

  const getFolderDetails = async (driveId: string, itemId: string, isDocubirdManagedLocation: boolean) => {
    const folderDetails = !props?.info?.folder?.isList
      ? await getItem(await authModule.getGraphAccessToken(), driveId, itemId, itemId && "listItem($select=webUrl)")
      : await getList(props.info.siteId ?? props.info.folder.siteId, driveId);

    if (folderDetails) {
      setSharePointIds(folderDetails.sharepointIds);
      setFolderPathArray(getItemPathArray(folderDetails.listItem?.webUrl ?? folderDetails.webUrl, isDocubirdManagedLocation));
    }
  }

  const getItemToShare = () => {
    let itemToShare: any = {
      ...props.info?.folder,
      sharepointIds: sharePointIds
    };

    if (Array.isArray(props.info?.locations) && props.info.locations.length > 0) {
      itemToShare.currentLocation = props.info.locations[props.info.locations.length - 1];
    }

    return itemToShare;
  }

  const addShareableLink = async () => {
    try {
      const emailer = new EmailCreatorFactory(false).create(languageStrings, props.mode);
      const url = await getItemWebViewUrl(
        await authModule.getGraphAccessToken(),
        props.info.folder.driveId,
        props.info.folder.id
      );
      await emailer.withShareableLink([
        { id: props.info?.folder?.id, driveId: props.info?.folder?.driveId, name: props.info?.folder?.name, webUrl: url }
      ]);
      props.dismissPanel();
    } catch (error) {
      logger(error, "FolderOptionPanel.tsx (addShareableLink)");
    }
  };

  const folderPropertiesButton = (
    <Stack horizontal>
      <ActionButton
        // iconProps={propertiesIcon}
        onRenderIcon={() => <Info20Regular />}
        allowDisabledFocus
        onClick={async () => {
          setIsFolderPropertiesPanelOpen(true);
        }}
      >
        {languageStrings.Properties}
      </ActionButton>
      {isFolderPropertiesPanelOpen && <CMFileInfoPanel infoPanelMode={InfoPanelMode.Update} panelIsOpen={isFolderPropertiesPanelOpen} closePanel={() => { setIsFolderPropertiesPanelOpen(false); generalModule.setIsFileInfoPanelOpen(false); }} webAddinItem={{ ...props?.info?.folder, sharepointIds: sharePointIds }} closeOnSuccess={metaDataUpdated} />}
    </Stack>
  )

  return (
    <>
      {isFolderDeletedDialogHidden && <Panel
        headerText={folderName}
        isLightDismiss={true}
        isOpen={props.info.isOpen}
        onDismiss={props.dismissPanel}
        closeButtonAriaLabel="Close"
        type={PanelType.custom}
        customWidth={!generalModule.isInConentMangerMode() ? "300px" : "350px"}
      >
        <div style={breadCrumbContainerStyles}>
          {folderPathArray?.length > 0 && <Breadcrumb
            styles={breadCrumbStyles}
            items={folderPathArray.map(x => ({ text: x, key: x }))}
          />}
        </div>
        {shareToTeamsButton}
        {props.info.isFromHomePage && props.info.isFromSuggestedItems && (
          <Stack {...rowProps} tokens={tokens.spinnerStack}>
            <ActionButton
              // iconProps={suggestionsIcon}
              onRenderIcon={() => <StarOff20Regular />}
              allowDisabledFocus
              onClick={() => {
                removeSuggestedItem();
              }}
            >
              {languageStrings.RemoveFromSuggestions}
            </ActionButton>
            {isAwaitingPinAction && <Spinner size={SpinnerSize.small} />}
          </Stack>
        )}
        {!isFolderPinned ? (
          <Stack {...rowProps} tokens={tokens.spinnerStack}>
            <ActionButton
              // iconProps={pinIcon}
              onRenderIcon={() => <Pin20Regular />}
              allowDisabledFocus
              disabled={isTeamChannelInfoLoading || isAwaitingPinAction}
              onClick={() => {
                pinFolderRedux();
              }}
            >
              {languageStrings.PinThisFolder}
            </ActionButton>
            {(isTeamChannelInfoLoading || isAwaitingPinAction) && <Spinner size={SpinnerSize.small} />}
          </Stack>
        ) : (
          <Stack {...rowProps} tokens={tokens.spinnerStack}>
            <ActionButton
              // iconProps={unpinIcon}
              onRenderIcon={() => <PinOff20Regular />}
              allowDisabledFocus
              disabled={isTeamChannelInfoLoading || isAwaitingPinAction}
              onClick={() => unpinFolder()}
            >
              {languageStrings.UnpinFolder}
            </ActionButton>
            {isAwaitingPinAction && <Spinner size={SpinnerSize.small} />}
          </Stack>
        )}
        {props.info.isARecentItem && (
          <Stack {...rowProps} tokens={tokens.spinnerStack}>
            <ActionButton
              // iconProps={removeFromRecentIcon}
              onRenderIcon={() => <DeleteArrowBack20Regular />}
              allowDisabledFocus
              onClick={() => removeRecentItem()}
            >
              {languageStrings.RemoveFromRecent}
            </ActionButton>
            {isAwaitingRecentAction && <Spinner size={SpinnerSize.small} />}
          </Stack>
        )}
        {otherButtonsNeedingLicensedAccess()}
        {props.tenantEnablePermissionManagement && generalModule.isInConentMangerMode() && !props.info?.folder.isSharedTeam
          && (props?.info?.folderType === FolderTypeEnum.sharepointSite || props?.info?.folderType === FolderTypeEnum.teamMainSite)
          && <Stack tokens={tokens.spinnerStack}>
            <ActionButton
              // iconProps={sitePermissions}KeyRegular
              onRenderIcon={() => <Key20Regular />}
              allowDisabledFocus
              text={languageStrings.SitePermissions}
              onClick={() => {
                setIsPermissionsPanelOpen(true);
              }}
            />
          </Stack>}
        {isFolderPinned && pinnedFolderIndex > -1 && (
          <>
            {pinnedFolderIndex !== 0 && <Stack {...rowProps} tokens={tokens.spinnerStack}>
              <ActionButton
                // iconProps={iconUp}
                onRenderIcon={() => <ArrowBetweenUp20Regular />}
                allowDisabledFocus
                onClick={() => props.MovePinnedItemUp(props.user.account.accountId, pinnedFolderIndex)}
              >
                {languageStrings.MoveItemUp}
              </ActionButton>
              {isAwaitingRecentAction && <Spinner size={SpinnerSize.small} />}
            </Stack>}
            {pinnedFolderIndex !== props.pinned.pinnedItems.length - 1 && <Stack {...rowProps} tokens={tokens.spinnerStack}>
              <ActionButton
                // iconProps={iconDown}
                onRenderIcon={() => <ArrowBetweenDown20Regular />}
                allowDisabledFocus
                onClick={() => props.MovePinnedItemDown(props.user.account.accountId, pinnedFolderIndex)}
              >
                {languageStrings.MoveItemDown}
              </ActionButton>
              {isAwaitingRecentAction && <Spinner size={SpinnerSize.small} />}
            </Stack>}
          </>
        )}
        {isPermissionsPanelOpen && <CMPermissionsPanel panelIsOpen={isPermissionsPanelOpen} closePanel={() => setIsPermissionsPanelOpen(false)} />}
      </Panel>}
      {folderDeletedDialog}
    </>
  );
};

export default connector(FolderOptionPanel);
